module.exports = __webpack_public_path__ + "img/give your brand the spotlight it deserves.466d1e33.jpeg";